import { render, staticRenderFns } from "./addLeadStoryModal.vue?vue&type=template&id=d3a88154&scoped=true"
import script from "./addLeadStoryModal.vue?vue&type=script&lang=js"
export * from "./addLeadStoryModal.vue?vue&type=script&lang=js"
import style0 from "./addLeadStoryModal.vue?vue&type=style&index=0&id=d3a88154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a88154",
  null
  
)

export default component.exports